import {Chip, Grid, Stack, Typography, useMediaQuery, useTheme} from "@mui/material";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ResearchService from '../../../model/database/ResearchService';
import ResponsiveGridItem from "../ResponsiveGridItem";
import StringGeneratorUtil from "../StringGeneratorUtil";
import KeywordsBadges from "./KeywordsBadges";

interface ServiceCardProps {
  useCard?: boolean,
  researchService?: ResearchService
  showState?: boolean
}

const ServiceCard = ({useCard, researchService, showState}: ServiceCardProps) => {
  const theme = useTheme();
  const matchMedia = useMediaQuery(theme.breakpoints.down('md'))

  const content = (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      spacing={2}>
      <ResponsiveGridItem>
        <Stack direction={matchMedia ? 'column': 'row'} spacing={1}>
          {showState && <Chip color={researchService?.product?.approved ? 'success' : 'error'}
                              label={researchService?.product?.approved ? 'Approvato' : 'Non approvato'}/>}
          <Typography variant="h6">{researchService?.product?.name}</Typography>
        </Stack>
          <Typography
              variant="subtitle1">{StringGeneratorUtil.generateProducerLabel(researchService?.producer!, true)}</Typography>
          <Typography variant="body2" textAlign="justify" sx={{whiteSpace: 'pre-line'}}>{researchService?.product?.description?.length! > 200 ? researchService?.product?.description?.substring(0, 200) + "..." : (researchService?.product?.description ?? '')}</Typography>
      </ResponsiveGridItem>
      <ResponsiveGridItem>
          <KeywordsBadges keywords={researchService?.product?.keywords!} matchMedia={matchMedia} />
      </ResponsiveGridItem>
    </Grid>
  );

  return (
    useCard ? <Card sx={{
      width: '100%',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'secondary.main',
        color: 'secondary.contrastText'
      }
    }}>
      <CardContent>
        {content}
      </CardContent>
    </Card> : content
  );
}

export default ServiceCard;
